var React = require('react');

function AudioPause (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M43 84c22.644 0 41-18.356 41-41S65.644 2 43 2 2 20.356 2 43s18.356 41 41 41zm0 2c23.748 0 43-19.252 43-43S66.748 0 43 0 0 19.252 0 43s19.252 43 43 43z","fill":"#fff","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M36 57.5V28h3v29.5h-3zM47.5 57.5V28h3v29.5h-3z","fill":"#fff","key":1})]);
}

AudioPause.defaultProps = {"width":"86","height":"86","fill":"none"};

module.exports = AudioPause;

AudioPause.default = AudioPause;
